import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useToast } from '@/hooks/use-toast';
import { authService } from '@/services/auth';
import { PartnerEmail } from '@/types/partner';

interface ResendInviteModalProps {
  isOpen: boolean;
  client: PartnerEmail | null;
  onClose: () => void;
  onSuccess: () => void;
}

export function ResendInviteModal({
  isOpen,
  client,
  onClose,
  onSuccess,
}: ResendInviteModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleResend = async () => {
    if (!client) return;
    setIsLoading(true);
    try {
      await authService.resendInvitation({ email: client.email });
      toast({
        title: 'Convite reenviado com sucesso.',
        description: `Se o e-mail existir, enviamos um novo link para ${client.email}.`,
      });
      onSuccess();
      onClose();
    } catch {
      toast({
        variant: 'error',
        title: 'Não foi possível reenviar o convite.',
        description: 'Tente novamente ou entre em contato com o suporte.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!client) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] w-[calc(100%-2rem)]">
        <DialogHeader>
          <DialogTitle>Reenviar convite</DialogTitle>
          <DialogDescription>
            Deseja reenviar o link de criação de senha para <strong>{client.email}</strong>?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button type="button" variant="dark" onClick={handleResend} disabled={isLoading}>
            {isLoading ? 'Reenviando...' : 'Reenviar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
